
<div class="usr-console">
  <div class="usr-console__header">
    <div class="user-profile-summary">
      <div class="usr__badge">
        <span>{{initials}}</span>
      </div>
      <div class="up__body">
        <span class="up__title">{{fullName}}</span>
        <span class="up__sub">{{email}}</span>
        <!-- <span class="up__sub brand-primary">Tutor Coordinator</span> -->
      </div>
    </div>
  </div>

  <!-- <div class="usr-console__section">
  <a href="" class="usr-console__command"><i class="las la-user-cog"></i> Your profile</a>
</div> -->
<div class="usr-console__section">
  @if (AccountSettingsEdit) {
    <a [routerLink]="['/settings']" class="usr-console__command usr-console__command--spin"
      (click)="routeActivated()"> <i class="las la-cog"></i> Settings </a>
    }
  </div>
  <div class="usr-console__section">
    <a (click)="logout()" class="usr-console__command"><i class="las la-power-off"></i> Logout</a>
  </div>
</div>